/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import styles from './spinner.scss';

export class Spinner extends React.Component {

  static propTypes = {
    size: PropTypes.number
  };

  render () {
    let sizeStyles = {};

    if (this.props.size) {
      sizeStyles = {
        width: this.props.size,
        height: this.props.size,
        borderWidth: Math.round(this.props.size / 10)
      };
    }

    return (
      <div className={styles.spinner} style={sizeStyles}></div>
    );
  }
}

export default Spinner;




/** WEBPACK FOOTER **
 ** ./src/components/spinner/spinner.js
 **/